import "../styles/AboutMe.css";
// import { FaCode, FaRocket, FaLightbulb } from "react-icons/fa";

export default function AboutMe() {
  return (
    <section className="about-me" id="about">
      <div className="about-container">
        <div className="about-text">
          <h2 className="about-title">About Me</h2>

          <p className="about-description">
            I am a software engineer focused on building machine learning
            workflows, data pipelines, and backend services.
            {/* <br />
            <br />
            My previous software work includes FISHES, an automation system for
            European Union funding applications, and Nanu, a real-time meeting
            insights tool. I also contribute to open source, including{" "}
            <a href="https://github.com/chidiwilliams/buzz">Buzz</a>, where I’ve
            worked on download resilience, UI responsiveness, and media playback
            stability. */}
          </p>

          {/* <div className="about-highlights">
            <div className="about-highlight">
              <FaCode className="highlight-icon" />
              <p className="highlight-text">
                <strong>Backend Engineering:</strong>I work primarily with
                Python (FastAPI) and Golang, designing high-performance APIs,
                background services, and cloud-native systems. I enjoy building
                infrastructure that scales, performs well under load, and
                remains maintainable over time.
              </p>
            </div>

            <div className="about-highlight">
              <FaRocket className="highlight-icon" />
              <p className="highlight-text">
                <strong>AI/ML Experience:</strong> I’ve contributed to products
                that integrate AI at scale, including: <br />
                - FISHES AI – an EU funding automation platform powered by
                backend workflows and AI-generated content. <br /> - Nanu – a
                real-time meeting insights tool processing audio, analytics, and
                live feedback.
              </p>
            </div>

            <div className="about-highlight">
              <FaLightbulb className="highlight-icon" />
              <p className="highlight-text">
                <strong>Learning & Growth: </strong>
                I’m actively sharpening my skills in: Distributed systems &
                high-performance backend architecture Go for systems-level and
                concurrent programming Cloud infrastructure, observability, and
                deployment automation
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
